<template>
  <div class="account-trade">
    <pageHeader title="账号交易" />

    <div class="page-container">
      <van-search
        v-model="gameName"
        @input="onInput"
        placeholder="搜索游戏名称"
      />

      <div class="trade-grid">
        <div
          :style="{ background: item.bgColor }"
          class="trade-grid-item"
          v-for="(item, i) in gridList"
          :key="i"
          @click="girdClick(item)"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="game-account-list">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div class="account-box">
            <div class="account-item" v-for="(item, i) in accountList" :key="i" @click="goToDetail(item)">
              <div class="account-info">
                <img :src="item.logoUrl" alt="" />
                <div class="account-amount">
                  <h1>{{ item.gameName }}</h1>
                  <span class="account-desc">{{ item.title }}</span>

                  <span class="total-sall"
                    >累计消费：{{ item.totalMoney || 0 }}元</span
                  >
                </div>
              </div>

              <span class="sall-price">￥{{ item.sallPrice }}</span>
            </div>
          </div>
        </van-list>
        <div class="empty-account" v-if="!accountList.length">
          <img src="@/assets/images/empty.png" alt="" />
          <span>什么也没有搜到</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import { debounce } from '../../../libs/utils';
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      gameName: "",
      gridList: [
        {
          icon: require("@/assets/images/trade-icon1.png"),
          label: "我要卖号",
          bgColor: "#FFFBF0",
          key: '/accountChose'
        },
        {
          icon: require("@/assets/images/trade-icon2.png"),
          label: "交易须知",
          bgColor: "#F1F7FF",
          key: '/tradingNotice'
        },
        {
          icon: require("@/assets/images/trade-icon3.png"),
          label: "交易记录",
          bgColor: "#FFF4F2",
          key: '/tradeRecord'
        },
      ],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      accountList: [],
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    finishedText() {
      if(!this.gameName) {
        return '暂无更多数据'
      } else {
        return ''
      }
    }
  },
  methods: {
    /**
     * 游戏账号搜索
     */
    onInput: debounce(function () {
      this.gameSearch()
    }, 500),

    gameSearch() {
      this.resetList()
      this.onLoad()
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.accountList = []; // 清空当前列表
      this.totalCount = 0;
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getAccountTradeList();
      this.accountList = [...this.accountList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 查询可出售账号列表
     */
    async getAccountTradeList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/accounttx/accountTx/getAllTransAccList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            searchParams: JSON.stringify({
              uuid: this.uuid,
              gameName: this.gameName,
            }),
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },
    /**
     * 跳转商品详情
     */
    goToDetail(scope) {
      this.$router.push({ path: '/goodsDetail', query: { id: scope.id } })
    },

    girdClick(info) {
      this.$router.push({ path: info.key })
    }
  },
};
</script>

<style lang="scss">
.account-trade {
  background: #f8f8f8;
  .page-container {
    .van-search__content {
      border-radius: 40px;
    }
    .van-search {
      position: sticky;
      top: 88px;
      z-index: 1000;
    }
  }
  .trade-grid {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    position: sticky;
    top: 194px;
    z-index: 1000;

    .trade-grid-item {
      width: 230px;
      height: 150px;
      border-radius: 16px;
      text-align: center;

      img {
        width: 80px;
        height: 80px;
        margin-top: 20px;
      }
      span {
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #333333;
      }
    }
  }

  .game-account-list {
    background: #f8f8f8;
  }

  .empty-account {
    text-align: center;
    height: calc(100vh - 386px);
    margin-top: 300px;
    img {
      width: 260px;
      height: 160px;
      margin-bottom: 20px;
    }
    span {
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #7f7f7f;
      line-height: 33px;
    }
  }
  .account-box {
    padding: 15px;
    background: #f8f8f8;
    .account-item {
      background: #fff;
      padding: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .account-info {
        display: flex;
        align-items: flex-start;
        img {
          width: 132px;
          height: 132px;
          margin-right: 20px;
        }

        .account-amount {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #191919;
            margin-bottom: 4px;
            line-height: 40px;
            max-width: 520px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .account-desc {
            display: block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #7f7f7f;
            line-height: 37px;
            margin-bottom: 14px;
            max-width: 520px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .total-sall {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #7f7f7f;
            line-height: 37px;
          }
        }
      }
      .sall-price {
        position: absolute;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #f44444;
        line-height: 45px;
        right: 45px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountTrade/index.vue